// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes RayvoOne_popIn__1Vi1U {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  70% {
    opacity: 1;
    transform: translateY(-10px); /* 轻微超调 */
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.RayvoOne_visionOneFeatures__r63wh {
  color: #fff;
  background-color: #fff;
  padding-top: 200px;
  padding-bottom: 200px;
  position: relative;
}

.RayvoOne_visionOneFeatures__r63wh::after {
  content: '';
  position: absolute;
  bottom: -1px;
  right: 0;
  width: 40px;
  height: 40px;
  background-color: #040404;
  clip-path: polygon(100% 0, 100% 100%, 0 100%);
}

.RayvoOne_wLayoutBlockcontainer__d8kNQ {
  max-width: 940px;
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.RayvoOne_wContainer__TkKE7 {
  margin-left: auto;
  margin-right: auto;
  max-width: 940px;
}

.RayvoOne_wContainer__TkKE7:before,
.RayvoOne_wContainer__TkKE7:after {
  content: " ";
  display: table;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-column-end: 2;
  grid-row-end: 2;
}

.RayvoOne_wContainer__TkKE7:after {
  clear: both;
}

.RayvoOne_container5__NQ8Op {
  max-width: 1300px;
  padding-left: 20px;
  padding-right: 20px;
}

.RayvoOne_divBlock18__jPhLB {
  justify-content: center;
  align-items: center;
  margin-bottom: 64px;
  display: flex;
}

.RayvoOne_divBlock19__86pmj {
  max-width: 802px;
  opacity: 0;
  transform: translateY(50px); /* 初始向下偏移 */
}

.RayvoOne_divBlock19__86pmj.RayvoOne_visible__h8Uo\\+ {
  animation: RayvoOne_popIn__1Vi1U 0.6s ease-out forwards;
}

.RayvoOne_textBlock15__o45Lb {
  color: var(--79);
  text-align: center;
  margin-top: 16px;
  font-size: 16px;
  line-height: 1.5;
  opacity: 0;
  transform: translateY(50px);
}

.RayvoOne_divBlock19__86pmj.RayvoOne_visible__h8Uo\\+ .RayvoOne_textBlock15__o45Lb {
  animation: RayvoOne_popIn__1Vi1U 0.6s ease-out 0.2s forwards; /* 延迟 0.2s */
}

.RayvoOne_features__pz3JL {
  display: grid;
  grid-column-gap: 24px;
  grid-row-gap: 24px;
  grid-template-rows: auto auto;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-columns: 1fr;
  opacity: 0;
  transform: translateY(50px);
}

.RayvoOne_features__pz3JL.RayvoOne_visible__h8Uo\\+ {
  animation: RayvoOne_popIn__1Vi1U 0.6s ease-out forwards;
}

.RayvoOne_heading8__9q8Z1 {
  color: #000;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 0;
  font-size: 72px;
  font-weight: 900;
  line-height: 1.2;
}

.RayvoOne_textBlock18__Ip0GT {
  color: #000;
  text-align: center;
  letter-spacing: 1px;
}

.RayvoOne_divBlock17__csR7R {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  color: #000;
  background-color: #fafafa;
  padding: 40px;
}

.RayvoOne_image4__7vgtQ {
  max-width: 32px;
}

.RayvoOne_textBlock8__1Z23Q {
  text-align: center;
  font-size: 24px;
  font-weight: 700;
}

.RayvoOne_boldText__ZRiJg,
.RayvoOne_boldText2__qsuKS,
.RayvoOne_boldText3__LCpqs,
.RayvoOne_boldText4__gd0Ll {
  color: #000;
}

.RayvoOne_textBlock9__V-RDF {
  color: var(--79);
  text-align: center;
  font-size: 18px;
  font-weight: 400;
}

.RayvoOne_buttonContainer__GWjFR {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 48px;
}

.RayvoOne_darkButton__IJ0Pj {
  background: black !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 0;
}

.RayvoOne_darkButton__IJ0Pj:hover {
  background: #1a1a1a !important;
  border-color: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.1) !important;
}

@media screen and (max-width: 991px) {
  .RayvoOne_visionOneFeatures__r63wh {
    padding-top: 100px;
    padding-bottom: 100px;
  }
  .RayvoOne_wLayoutBlockcontainer__d8kNQ {
    max-width: 728px;
  }
  .RayvoOne_wContainer__TkKE7 {
    max-width: 728px;
  }
  .RayvoOne_heading8__9q8Z1 {
    font-size: 36px;
  }
  .RayvoOne_features__pz3JL {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 767px) {
  .RayvoOne_wLayoutBlockcontainer__d8kNQ {
    max-width: none;
  }
  .RayvoOne_features__pz3JL {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 479px) {
  .RayvoOne_wContainer__TkKE7 {
    max-width: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/RayvoOne/RayvoOne.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,4BAA4B,EAAE,SAAS;EACzC;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,2BAA2B,EAAE,WAAW;AAC1C;;AAEA;EACE,uDAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,4DAA4C,EAAE,YAAY;AAC5D;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,sBAAsB;EACtB,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,uDAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,0CAA0C;EAC1C,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@keyframes popIn {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  70% {\n    opacity: 1;\n    transform: translateY(-10px); /* 轻微超调 */\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.visionOneFeatures {\n  color: #fff;\n  background-color: #fff;\n  padding-top: 200px;\n  padding-bottom: 200px;\n  position: relative;\n}\n\n.visionOneFeatures::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  right: 0;\n  width: 40px;\n  height: 40px;\n  background-color: #040404;\n  clip-path: polygon(100% 0, 100% 100%, 0 100%);\n}\n\n.wLayoutBlockcontainer {\n  max-width: 940px;\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n.wContainer {\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 940px;\n}\n\n.wContainer:before,\n.wContainer:after {\n  content: \" \";\n  display: table;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-column-end: 2;\n  grid-row-end: 2;\n}\n\n.wContainer:after {\n  clear: both;\n}\n\n.container5 {\n  max-width: 1300px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.divBlock18 {\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 64px;\n  display: flex;\n}\n\n.divBlock19 {\n  max-width: 802px;\n  opacity: 0;\n  transform: translateY(50px); /* 初始向下偏移 */\n}\n\n.divBlock19.visible {\n  animation: popIn 0.6s ease-out forwards;\n}\n\n.textBlock15 {\n  color: var(--79);\n  text-align: center;\n  margin-top: 16px;\n  font-size: 16px;\n  line-height: 1.5;\n  opacity: 0;\n  transform: translateY(50px);\n}\n\n.divBlock19.visible .textBlock15 {\n  animation: popIn 0.6s ease-out 0.2s forwards; /* 延迟 0.2s */\n}\n\n.features {\n  display: grid;\n  grid-column-gap: 24px;\n  grid-row-gap: 24px;\n  grid-template-rows: auto auto;\n  grid-template-columns: 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  opacity: 0;\n  transform: translateY(50px);\n}\n\n.features.visible {\n  animation: popIn 0.6s ease-out forwards;\n}\n\n.heading8 {\n  color: #000;\n  text-align: center;\n  margin-top: 20px;\n  margin-bottom: 0;\n  font-size: 72px;\n  font-weight: 900;\n  line-height: 1.2;\n}\n\n.textBlock18 {\n  color: #000;\n  text-align: center;\n  letter-spacing: 1px;\n}\n\n.divBlock17 {\n  display: flex;\n  flex-flow: column;\n  justify-content: center;\n  align-items: center;\n  grid-column-gap: 16px;\n  grid-row-gap: 16px;\n  color: #000;\n  background-color: #fafafa;\n  padding: 40px;\n}\n\n.image4 {\n  max-width: 32px;\n}\n\n.textBlock8 {\n  text-align: center;\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.boldText,\n.boldText2,\n.boldText3,\n.boldText4 {\n  color: #000;\n}\n\n.textBlock9 {\n  color: var(--79);\n  text-align: center;\n  font-size: 18px;\n  font-weight: 400;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 48px;\n}\n\n.darkButton {\n  background: black !important;\n  color: white !important;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  margin: 0;\n}\n\n.darkButton:hover {\n  background: #1a1a1a !important;\n  border-color: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 4px 12px rgba(255, 255, 255, 0.1) !important;\n}\n\n@media screen and (max-width: 991px) {\n  .visionOneFeatures {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n  .wLayoutBlockcontainer {\n    max-width: 728px;\n  }\n  .wContainer {\n    max-width: 728px;\n  }\n  .heading8 {\n    font-size: 36px;\n  }\n  .features {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .wLayoutBlockcontainer {\n    max-width: none;\n  }\n  .features {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .wContainer {\n    max-width: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visionOneFeatures": `RayvoOne_visionOneFeatures__r63wh`,
	"wLayoutBlockcontainer": `RayvoOne_wLayoutBlockcontainer__d8kNQ`,
	"wContainer": `RayvoOne_wContainer__TkKE7`,
	"container5": `RayvoOne_container5__NQ8Op`,
	"divBlock18": `RayvoOne_divBlock18__jPhLB`,
	"divBlock19": `RayvoOne_divBlock19__86pmj`,
	"visible": `RayvoOne_visible__h8Uo+`,
	"popIn": `RayvoOne_popIn__1Vi1U`,
	"textBlock15": `RayvoOne_textBlock15__o45Lb`,
	"features": `RayvoOne_features__pz3JL`,
	"heading8": `RayvoOne_heading8__9q8Z1`,
	"textBlock18": `RayvoOne_textBlock18__Ip0GT`,
	"divBlock17": `RayvoOne_divBlock17__csR7R`,
	"image4": `RayvoOne_image4__7vgtQ`,
	"textBlock8": `RayvoOne_textBlock8__1Z23Q`,
	"boldText": `RayvoOne_boldText__ZRiJg`,
	"boldText2": `RayvoOne_boldText2__qsuKS`,
	"boldText3": `RayvoOne_boldText3__LCpqs`,
	"boldText4": `RayvoOne_boldText4__gd0Ll`,
	"textBlock9": `RayvoOne_textBlock9__V-RDF`,
	"buttonContainer": `RayvoOne_buttonContainer__GWjFR`,
	"darkButton": `RayvoOne_darkButton__IJ0Pj`
};
export default ___CSS_LOADER_EXPORT___;
